import { Component, Input } from '@angular/core';
import { ViewBreakpointService } from '@common-module/app-services/view-breakpoint.service';
import { UnitAdditionalData } from '@common-module/modelinterfaces/unit-additional-data.model';
import { NgClass, AsyncPipe } from '@angular/common';
import { CurrentDriverComponent } from '../../../../../shared/components/current-driver/current-driver.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-driver-card',
    templateUrl: './driver-card.component.html',
    styleUrls: ['../carousel-card-styles.component.scss'],
    imports: [NgClass, CurrentDriverComponent, AsyncPipe, TranslateModule]
})

export class DriverCardComponent {

  @Input() width: number;
  @Input() unitData: UnitAdditionalData;

  constructor(public viewBreakpointService: ViewBreakpointService) {
  }
}
